
export enum MatchmakingMatchTypes {
    WeeklyRotatingFunGame,
    RankedClassic4P,
    UnrankedClassic4P,
    RankedClassic56P,
    UnrankedClassic56P,
    RankedSeafarers4P,
    UnrankedSeafareres4P,
    RankedSeafarers56P,
    UnrankedSeafareres56P,
    RankedCitiesAndKnights4P,
    UnrankedCitiesAndKnights4P,
    RankedCitiesAndKnights56P,
    UnrankedCitiesAndKnights56P,
    UnrankedClassic1v1,
    UnrankedClassicFreeMapRotation, // Jan 30, 2022. Jeff: Removed because it was very unpopular. Do not delete enum.
    RankedClassic1v1,
    UnrankedShuffle,
}

export enum BotsMatchType {
    BeginnerMode = 'beginner-mode',
    Easy = 'bots-easy',
    Medium = 'bots-medium',
    Hard = 'bots-hard',
}

export type MatchType = MatchmakingMatchTypes | BotsMatchType

export const MODE_BASE_PLAYTIME_MINUTES = {
    CLASSIC: 25,
    CITIES_AND_KNIGHTS: 40,
    SEAFARERS: 25,
    CITIES_AND_KNIGHTS_SEAFARERS: 40,
    COLONIST_RUSH: 10,
    CLASSIC_1V1: 10,
    BOTS_BEGINNER_MODE: 5,
    BOTS_STANDARD: 10,
}
